import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const ROOT_WIDTH = 246;

export const useStyles = makeStyles<{ position: number }>()(
  (theme, { position }) => ({
    root: {
      display: 'flex',
      borderRadius: 10,
      border: `1px solid ${theme.palette.background.default}`,
      minWidth: ROOT_WIDTH,
      position: 'relative',
      height: 26,

      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: `calc((100% / 3) * ${position})`,
        width: `calc(100% / 3)`,
        height: '100%',
        backgroundColor: theme.palette.primary.main,
        borderRadius: 8,
        transition: 'left 0.3s ease-in-out',
      },
    },

    button: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 500,
      letterSpacing: '0.14px',
      border: 'none',
      background: 'transparent',
      position: 'relative',
      color: alpha(theme.palette.secondary.contrastText, 0.6),
      transition: 'color 0.3s ease-in-out',
      cursor: 'pointer',

      '&:hover': {
        color: theme.palette.secondary.contrastText,
      },
    },

    active: {
      '&&, &&:hover': {
        color: theme.palette.primary.contrastText,
      },
    },
  }),
);
